cb.define([], function () {
  var SH_sh_aftersale_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
		var self = this;
		//self.btnBrowseShowAndDis(viewmodel);
		//self.btnEditShowAndDis(viewmodel);
		viewmodel.on('afterLoadData', function (data){
			viewmodel.get("chargeItem").setDirty(true);
			var mode = viewmodel.getParams().mode;
			var bstatus = viewmodel.getParams().billData.status;
			if (mode == "edit" && bstatus != 0 )
			{
				viewmodel.get("customerName").setReadOnly(true);
				viewmodel.get("phone").setReadOnly(true);
				viewmodel.get("receiverid_name").setReadOnly(true);
				viewmodel.get("receiverTime").setReadOnly(true);
				viewmodel.get("productsku_cCode").setReadOnly(true);
				viewmodel.get("productDescribe").setReadOnly(true);
				viewmodel.get("estimatedPickTime").setReadOnly(true);
				viewmodel.get("product_cName").setReadOnly(true);
				viewmodel.get("maintenancePlace").setReadOnly(true);
				viewmodel.get("batchno").setReadOnly(true);
				viewmodel.get('chargeItem').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define1').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define2').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define3').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define4').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define5').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define6').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define7').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define8').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define9').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define10').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define11').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define12').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define13').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define14').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define15').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define16').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define17').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define18').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define19').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define20').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define21').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define22').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define23').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define24').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define25').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define26').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define27').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define28').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define29').setReadOnly(true);
				viewmodel.get('afterSaleCustomItem!define30').setReadOnly(true);
			}
		});
		
		viewmodel.on('beforeSave', function (args) {
			debugger
			var data = JSON.parse(args.data.data);
			if(data.chargeItem.length > 0)
			{
				var rows = data.chargeItem;
				var sum = 0;
				rows.forEach(function(item,index){
					if(item.markPrice != undefined && item.markPrice != 0)
						sum = (parseFloat(sum*1) + parseFloat((item.markPrice)*1)).toFixed(2);
				});
				data.gatheringMoney = sum;
				data.totalCost = sum;
				args.data.data = JSON.stringify(data);
			}else{
				data.gatheringMoney = 0;
				data.totalCost = 0;
				args.data.data = JSON.stringify(data);
			}
		});
    },
  }
  try {
    module.exports = SH_sh_aftersale_VM_Extend;
  } catch (error) {

  }
  return SH_sh_aftersale_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/SH/SH_sh_aftersale_VM.Extend.js